/**
 * Application Configuration
 *
 * For separate deployment, set VITE_API_URL in your .env file:
 * VITE_API_URL=https://api.yourcompany.com
 *
 * If not set, it defaults to relative URLs (same-domain deployment)
 */

// Base URL for API requests
// In development: uses Vite proxy (relative URL)
// In production: can be set via VITE_API_URL environment variable
export const API_BASE_URL = import.meta.env.VITE_API_URL || "";

// Full admin API base URL
export const ADMIN_API_URL = `${API_BASE_URL}/admin/api`;

/**
 * Build full API URL for admin endpoints
 * @param path - API path starting with / (e.g., "/organizations")
 * @returns Full URL
 */
export function adminApiUrl(path: string): string {
	return `${ADMIN_API_URL}${path}`;
}
